import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AuthService } from '@nutrix/data-access-auth';
import { MfaStateService } from '@nutrix/data-access-mfa';

export const dataAccessAuthGuard: CanActivateFn = (route, state) => {
  const usersService = inject(AuthService);
  const router = inject(Router);
  const message = inject(MessageService);
  const requirePhoneSetup = inject(MfaStateService).requirePhoneSetup;

  const currentUser = usersService.loadCurrentUser();
  if (currentUser == null) {
    message.add({
      severity: 'warning',
      summary: 'Por favor, inicie sesión',
    });
    router.navigate(['login']);
    return false;
  }
  if (!currentUser?.admin === true) {
    if (currentUser?.user === false || currentUser?.patient === true || currentUser?.dashboardAccess === false) {
      message.add({
        severity: 'warning',
        summary: 'No tiene permisos para acceder a esta página',
      });
      usersService.logout();
      router.navigate(['login']);
      return false;
    }
  }
  const provider = JSON.parse(localStorage.getItem('nutrixAuthType') || '{}').name;
  const isMfaEnabled = currentUser?.isMfaEnabled === 'True' ? true : false;

  if (provider !== 'aad' && !isMfaEnabled && state.url !== '/profile') {
    requirePhoneSetup.set(true);
    router.navigate(['profile']);
    return false;
  }

  sessionStorage.setItem('destination-url', state.url);
  return true;
};
